import React from "react";
import Sidebar from "components/Sidebar/Sidebar";
import { NavLink } from "react-router";
import SidebarHeader from "components/Sidebar/SidebarHeader";
import { isAuthenticated, isDeveloperToolsUser } from "services/self";
import Editor from "components/Sidebar/Editor";
import { useLocation } from "react-router";
import { NON_PROD } from "utils/constants";

function SideNav() {
  const { pathname } = useLocation();

  return (
    <Sidebar>
      <SidebarHeader>Developer Tools</SidebarHeader>
      {isAuthenticated() && NON_PROD && (
        <NavLink
          to="/developer-tools/websocket-test-client"
          className="item link"
        >
          WebSocket Test Client
        </NavLink>
      )}
      {isDeveloperToolsUser() && (
        <NavLink
          to="/developer-tools/api-gw-self-service"
          className="item link"
        >
          API GW Self-Service
        </NavLink>
      )}
      {isAuthenticated() && NON_PROD && (
        <NavLink
          to="/developer-tools/json-yaml-editor"
          className="item link"
        >
          JSON/YAML editor
        </NavLink>
      )}
      {isDeveloperToolsUser() && NON_PROD && (
        <>
          <NavLink
            to="/developer-tools/api-specification-editor"
            className="item link"
          >
            API Specification Editor
          </NavLink>
          {pathname.includes("api-specification-editor") && <Editor />}
        </>
      )}
    </Sidebar>
  );
}

export default SideNav;
